// The on-account pool per customer/supplier, built ONE way for every screen (Receivables callout, Allocate Payments, customer page breakdown).
// Customers: amount = the API's credit_on_account and the kinds = credit_on_account_by_kind (pool purity already applied server-side: order-tied credits such as a
// price adjustment never reach the pool). Only when the API does not send the split do we read the pool items' open_by_kind / open_amount, falling back to the ledger
// by_kind / amount when those fields are absent. No proportional scaling anywhere.
const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const mag = (o) => Object.fromEntries(Object.entries(o || {}).map(([k, v]) => [k, r2(Math.abs(Number(v) || 0))]).filter(([, v]) => v > 0));

// positive-magnitude kinds of one customer position row (a row carrying credit_on_account_by_kind) or null when unknown
export const poolKindsOf = (row) => (row && row.credit_on_account_by_kind ? mag(row.credit_on_account_by_kind) : null);

export function onAccountRows(agedRows, isRecv) {
  const out = [], seen = new Set();
  for (const row of (agedRows || [])) {
    if (row.account_role) continue;   // Deferred Revenue / Customer Refund Held are advances / refund to pay, not an unapplied payment
    const pool = (row.items || []).filter(it => !it.operation_id);
    const amt = -pool.reduce((s, it) => s + (Number(it.open_amount ?? it.amount) || 0), 0);
    let eff = amt, by_kind;
    if (isRecv && row.credit_on_account != null) {
      if (seen.has(row.partner_id) || amt <= 0) continue;
      seen.add(row.partner_id); eff = Number(row.credit_on_account) || 0; by_kind = poolKindsOf(row);
    }
    if (!(eff > 0.5)) continue;
    if (!by_kind) { const bk = {}; for (const it of pool) for (const [k, v] of Object.entries(it.open_by_kind || it.by_kind || {})) bk[k] = (bk[k] || 0) - (Number(v) || 0); by_kind = mag(bk); }
    out.push({ account_id: row.account_id, partner_id: row.partner_id, partner_name: row.partner_name, account_name: row.account_name, amount: r2(eff), by_kind });
  }
  return out;
}
